import { render, staticRenderFns } from "./AddWorkers.vue?vue&type=template&id=c17f6346&scoped=true"
import script from "./AddWorkers.vue?vue&type=script&lang=js"
export * from "./AddWorkers.vue?vue&type=script&lang=js"
import style0 from "./AddWorkers.vue?vue&type=style&index=0&id=c17f6346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c17f6346",
  null
  
)

export default component.exports